/**
 * On Course Wedge Play Reducers
 */
import {
    OCTWEDGE_ACTION,
    ALL_OCTWEDGE,
    ADD_OCTWEDGE,
    FETCH_OCTWEDGE,
    EDIT_OCTWEDGE,
    DELETE_OCTWEDGE,
    FETCH_OCTWEDGECHART,
    FETCH_WEDGESHOTCHART,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    octwedgelist:[],
    particularoctwedge:[],
    wedgechart:[],
    wedgeshotchart:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case OCTWEDGE_ACTION:
            return { ...state, loading: true };       

        case ALL_OCTWEDGE:
            return { ...state, loading: false, octwedgelist: action.payload };     
            
        case ADD_OCTWEDGE:
            return { ...state, loading: false };     
         
        case FETCH_OCTWEDGE:
            return { ...state, loading: false, particularoctwedge: action.payload };  
            
        case EDIT_OCTWEDGE:
            return { ...state, loading: false }; 
            
        case DELETE_OCTWEDGE:
            return { ...state, loading: false };   
            
        case FETCH_OCTWEDGECHART:
            return { ...state, loading: false, wedgechart: action.payload };  

        case FETCH_WEDGESHOTCHART:
            return { ...state, loading: false, wedgeshotchart: action.payload };  
        
        default: return { ...state };

     }
 }